import { get } from '../../utils/object-helpers';
import { getGlobals } from '../../utils/global-variables';
import { buildErrorMessageModule } from '../../utils/default-error-message';

const UPLOADER_ID = 'logoUploader';
const LOGO_FIELD_NAME = 'userLogoUrl';

export default class {
    onCreate(input) {
        const editLogoAction = get(input, 'editLogoAction', {});
        const initialLogo = get(input, 'logo.URL', '');
        this.enableLogoUpload = Object.keys(editLogoAction).length > 0;
        this.editMenuEntries = get(editLogoAction, 'editMenu.entries', []);
        this.maxFileSize = +get(editLogoAction, 'iconAdd.action.params.logoSizeLimitMB', 0);
        this.maxFileSize = this.maxFileSize * 1024 * 1024;
        this.defaultLogoUrl = get(editLogoAction, 'defaultLogo.URL', '');
        this.acceptedFileTypes = get(editLogoAction, 'iconAdd.action.params.logoAllowedExtensions', '');
        this.state = {
            logoUrl: get(input, 'logo.URL', ''),
            editMenuRequired: initialLogo !== this.defaultLogoUrl,
            removeIntention: false
        };
    }
    onMount() {
        if (this.enableLogoUpload) {
            import('@selling-ui/uploader').then(({ default: Uploader }) => {
                const newUploader = new Uploader();
                const { config: { logoUploaderConfig = {} } = {} } = getGlobals();
                logoUploaderConfig.accept = this.acceptedFileTypes;
                logoUploaderConfig.epsData = logoUploaderConfig;
                this.uploader = newUploader.setup(logoUploaderConfig, 0, UPLOADER_ID);
                if (!window.sellingUIUploader) {
                    window.sellingUIUploader = {};
                }
                window.sellingUIUploader[UPLOADER_ID] = newUploader;
                window.sellingUIUploader[UPLOADER_ID].config = logoUploaderConfig;
                this.uploadSuccess = (fileId, data) => {
                    if (data.url) {
                        this.updateLogo(data.url);
                        this.state.editMenuRequired = true;
                    }
                };
                this.uploadFail = (fileId, response) => {
                    const errorEventDetail = {
                        action: {
                            name: 'SET_SAVE_EDIT_ERROR'
                        },
                        payload: {
                            modules: {
                                STATUS_MESSAGE_INLINE_MODULE:
                                    buildErrorMessageModule(response.errorId || response.epsErrorId)
                            }
                        }
                    };
                    document.dispatchEvent(new CustomEvent('presenceEdit', { detail: errorEventDetail }));
                };
                this.uploader.addListener('upload-success', this.uploadSuccess);
                this.uploader.addListener('upload-fail', this.uploadFail);

                setTimeout(() => {
                    this.updateLogo(this.state.logoUrl);
                }, 0);
            }).catch(err => {
                console.warn('There was a problem loading the uploader library');
                console.error(err);
            });
        }
    }
    onInput(input) {
        const updatedLogoUrl = get(input, `globalState.profileEdit.payload.${LOGO_FIELD_NAME}`);
        if (updatedLogoUrl !== undefined) {
            this.state.logoUrl = updatedLogoUrl;
        }
    }
    addLogo() {
        const uploader = get(window, `sellingUIUploader.${UPLOADER_ID}`, null);
        if (uploader) {
            uploader.browse(0, 100);
        }
    }
    iconMenuOptionSelected(ev) {
        const selected = this.editMenuEntries[ev.index]?.action?.name;
        switch (selected) {
            case 'EDIT_LOGO_MENU_ADD':
                this.addLogo();
                break;
            case 'EDIT_LOGO_MENU_REMOVE':
                this.intentionLogoRemoval();
                break;
            default:
                console.warn('Unexpected action name for profile logo edit', selected);
                break;
        }
    }
    intentionLogoRemoval() {
        this.state.removeIntention = true;
    }
    confirmLogoRemoval() {
        this.updateLogo(this.defaultLogoUrl);
        this.state.editMenuRequired = false;
        this.state.removeIntention = false;
    }
    cancelLogoRemoval() {
        this.state.removeIntention = false;
    }
    updateLogo(value) {
        const eventDetail = {
            action: {
                name: 'UPDATE_PROFILE_FIELD'
            },
            payload: {
                field: LOGO_FIELD_NAME,
                value
            }
        };
        document.dispatchEvent(new CustomEvent('presenceEdit', { detail: eventDetail }));
    }
}
